import axios from "axios";

const metricaApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND}/metrica`
})

async function servGetmetricas(metricaQuatorze) {
    const response = await metricaApi.get('/resumido', {
        params: { metricaQuatorze }
    })
    return response.data
}

export {
    servGetmetricas,
}